import React from "react";
import { WarningOutlined } from "@ant-design/icons";
import { Flex, Tooltip, Typography } from "antd";
import { useTranslation } from "react-i18next";

type Props = {
  name: string;
};

const BlackListedCompanyName = React.memo(({ name }: Props) => {
  const { t } = useTranslation("translations");

  return (
    <Typography.Text type="warning" ellipsis style={{ fontSize: "inherit" }}>
      <Flex gap={4}>
        <Tooltip title={t("this_comapny_in_black_list")}>
          <WarningOutlined />
        </Tooltip>
        {name}
      </Flex>
    </Typography.Text>
  );
});

export default BlackListedCompanyName;
